var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#15142C",
    stroke: "#070D27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0494 18.4179C11.9931 18.2658 10.9791 18.1137 9.96502 17.97C9.68616 17.9278 9.4242 17.8771 9.33124 17.5644C9.24674 17.2771 9.43265 17.0827 9.62701 16.9137C11.6382 15.0462 13.9959 13.9561 16.7422 13.7786C17.0971 13.7533 17.376 13.6519 17.638 13.3899C20.2998 10.6604 23.511 8.97036 27.2629 8.32814C27.9136 8.21828 28.5728 8.18448 29.2403 8.20138C29.7474 8.21828 29.8826 8.34504 29.891 8.86051C29.9333 10.9816 29.4009 12.9843 28.5558 14.911C27.6263 17.0236 26.3334 18.8911 24.6602 20.4798C24.4152 20.7164 24.3307 20.9868 24.3053 21.2995C24.1363 24.0205 23.0716 26.3612 21.2463 28.364C21.1956 28.4147 21.1533 28.4654 21.0942 28.5161C20.9252 28.6766 20.7393 28.8034 20.4857 28.7189C20.2238 28.6259 20.1393 28.4147 20.1055 28.1612C19.9618 27.1302 19.8097 26.1077 19.6576 25.0683C19.59 25.0768 19.5477 25.0768 19.5139 25.0937C18.821 25.5838 18.821 25.5838 18.221 24.9838C16.5563 23.3107 14.8747 21.6206 13.1931 19.939C12.517 19.2629 12.517 19.2629 13.0494 18.4179ZM23.6715 16.5926C24.9137 16.5926 25.8686 15.6462 25.8686 14.404C25.8686 13.204 24.8968 12.2238 23.6969 12.2238C22.4462 12.2153 21.4998 13.1618 21.4998 14.404C21.4913 15.6631 22.4124 16.5926 23.6715 16.5926Z",
    fill: "url(#paint0_linear_204_4086)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25.5246C15.424 26.4373 15.0691 27.2485 14.2156 27.7724C13.1001 28.4484 11.8748 28.8625 10.6495 29.2935C10.0833 29.4963 9.50027 29.6822 8.92564 29.8428C8.39327 29.9949 8.0806 29.6822 8.24116 29.1498C8.73973 27.4767 9.29746 25.8288 10.0833 24.2571C10.5312 23.3698 11.2072 22.7951 12.2044 22.6346C13.9198 22.3642 15.5254 23.7416 15.5 25.5246Z",
    fill: "url(#paint1_linear_204_4086)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6804 15.9672C24.5391 15.9672 25.2352 15.271 25.2352 14.4123C25.2352 13.5536 24.5391 12.8574 23.6804 12.8574C22.8216 12.8574 22.1255 13.5536 22.1255 14.4123C22.1255 15.271 22.8216 15.9672 23.6804 15.9672Z",
    fill: "url(#paint2_linear_204_4086)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_4086",
    x1: 18.3393,
    y1: 19.6009,
    x2: 31.3234,
    y2: 8.13336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808BF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_4086",
    x1: 10.5228,
    y1: 28.009,
    x2: 14.7903,
    y2: 23.7416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8845B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0603A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_204_4086",
    x1: 24.6774,
    y1: 12.925,
    x2: 22.3113,
    y2: 15.2911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CCF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocketIcon.46a79321a091084c6cf91c2d69432fc7.svg";
export { ForwardRef as ReactComponent };